var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _vm.opened
    ? _c("div", { staticClass: "modal-mask" }, [
        _c("div", { staticClass: "modal-wrapper" }, [
          !_vm.initialized
            ? _c("div", { staticClass: "modal-dialog" }, [
                _c("div", { staticClass: "modal-content" }, [
                  _c("div", { staticClass: "modal-header" }, [
                    _c("h5", { staticClass: "modal-title" }, [
                      _vm._v("Delete criterion"),
                    ]),
                    _vm._v(" "),
                    _c(
                      "button",
                      {
                        staticClass: "close",
                        attrs: { type: "button" },
                        on: { click: _vm.close },
                      },
                      [_vm._v("×")]
                    ),
                  ]),
                  _vm._v(" "),
                  _vm._m(0),
                  _vm._v(" "),
                  _c("div", { staticClass: "modal-footer" }, [
                    _c(
                      "button",
                      {
                        staticClass: "btn btn-outline-secondary",
                        attrs: { type: "button" },
                        on: { click: _vm.close },
                      },
                      [_vm._v("Cancel")]
                    ),
                  ]),
                ]),
              ])
            : _vm._e(),
          _vm._v(" "),
          _vm.initialized && _vm.hasDependants
            ? _c(
                "div",
                {
                  staticClass: "modal-dialog modal-lg modal-dialog-scrollable",
                },
                [
                  _c("div", { staticClass: "modal-content" }, [
                    _c("div", { staticClass: "modal-header" }, [
                      _c("h5", { staticClass: "modal-title" }, [
                        _vm._v("Delete criterion"),
                      ]),
                      _vm._v(" "),
                      _c(
                        "button",
                        {
                          staticClass: "close",
                          attrs: { type: "button" },
                          on: { click: _vm.close },
                        },
                        [_vm._v("×")]
                      ),
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "modal-body" }, [
                      _c(
                        "div",
                        {
                          staticClass: "alert alert-danger text-dark",
                          attrs: { role: "alert" },
                        },
                        [
                          _c("h5", { staticClass: "alert-heading" }, [
                            _vm._v("Cannot delete this criterion"),
                          ]),
                          _vm._v(" "),
                          _c("p", [
                            _vm._v(
                              "\n                            The criterion '"
                            ),
                            _c("strong", [_vm._v(_vm._s(_vm.criterionName))]),
                            _vm._v("' is used in "),
                            _c("strong", [
                              _vm._v(_vm._s(_vm.dependenciesCount)),
                            ]),
                            _vm._v(
                              " places.\n                            To delete this criterion, first remove it from where it is used.\n                        "
                            ),
                          ]),
                        ]
                      ),
                      _vm._v(" "),
                      _c("div", [
                        _vm.weightedScores.length > 0
                          ? _c("div", { staticClass: "card" }, [
                              _c("div", { staticClass: "card-header" }, [
                                _vm._v(
                                  "\n                                Weighted scores ("
                                ),
                                _c("span", [
                                  _vm._v(_vm._s(_vm.weightedScores.length)),
                                ]),
                                _vm._v(")\n                            "),
                              ]),
                              _vm._v(" "),
                              _c(
                                "ul",
                                { staticClass: "list-group list-group-flush" },
                                _vm._l(_vm.weightedScores, function (ws) {
                                  return _c(
                                    "li",
                                    {
                                      key: ws.Id,
                                      staticClass: "list-group-item",
                                    },
                                    [
                                      _c(
                                        "a",
                                        {
                                          directives: [
                                            {
                                              name: "sanitizedHref",
                                              rawName: "v-sanitizedHref",
                                              value:
                                                _vm.url_EditWeightedScorePage(
                                                  ws
                                                ),
                                              expression:
                                                "url_EditWeightedScorePage(ws)",
                                            },
                                          ],
                                          staticClass: "text-primary",
                                        },
                                        [_vm._v(_vm._s(ws.Name))]
                                      ),
                                      _c("br"),
                                      _vm._v(" "),
                                      _c(
                                        "small",
                                        { staticClass: "text-muted" },
                                        [_vm._v(_vm._s(ws.Path))]
                                      ),
                                    ]
                                  )
                                }),
                                0
                              ),
                            ])
                          : _vm._e(),
                      ]),
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "modal-footer" }, [
                      _c(
                        "button",
                        {
                          staticClass: "btn btn-outline-secondary",
                          attrs: { type: "button" },
                          on: { click: _vm.close },
                        },
                        [_vm._v("Close")]
                      ),
                    ]),
                  ]),
                ]
              )
            : _vm._e(),
          _vm._v(" "),
          _vm.initialized && !_vm.hasDependants
            ? _c("div", { staticClass: "modal-dialog" }, [
                _c("div", { staticClass: "modal-content" }, [
                  _c(
                    "div",
                    { staticClass: "modal-header bg-danger text-white" },
                    [
                      _c("h5", { staticClass: "modal-title" }, [
                        _vm._v("Delete criterion"),
                      ]),
                      _vm._v(" "),
                      _c(
                        "button",
                        {
                          staticClass: "close text-white",
                          attrs: { type: "button" },
                          on: { click: _vm.close },
                        },
                        [_vm._v("×")]
                      ),
                    ]
                  ),
                  _vm._v(" "),
                  _c("div", { staticClass: "modal-body" }, [
                    _c("h4", [
                      _vm._v("Are you sure you want to delete this criterion?"),
                    ]),
                    _vm._v(" "),
                    _c("p", [
                      _vm._v("You are about to delete '"),
                      _c("strong", [_vm._v(_vm._s(_vm.criterionName))]),
                      _vm._v("'. Deleting a criterion will also delete its "),
                      _c("strong", [_vm._v("sub-criteria")]),
                      _vm._v(". This can't be undone."),
                    ]),
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "modal-footer" }, [
                    _c(
                      "button",
                      {
                        staticClass: "btn btn-danger",
                        attrs: { type: "button" },
                        on: { click: _vm.emitDeleteCriterion },
                      },
                      [_vm._v("Delete")]
                    ),
                    _vm._v(" "),
                    _c(
                      "button",
                      {
                        staticClass: "btn btn-outline-secondary",
                        attrs: { type: "button" },
                        on: { click: _vm.close },
                      },
                      [_vm._v("Cancel")]
                    ),
                  ]),
                ]),
              ])
            : _vm._e(),
        ]),
      ])
    : _vm._e()
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c,
      _setup = _vm._self._setupProxy
    return _c("div", { staticClass: "modal-body" }, [
      _c("h4", [
        _c("i", { staticClass: "fa fa-spinner fa-spin" }),
        _vm._v(" Checking dependencies..."),
      ]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }